import $ from "jquery";

const history_slider = function () {
  $('.js-history-slider').slick({
    lazyLoad: 'ondemand',
    mobileFirst: true,
    'dots': true,
    'arrows': true,
    'infinite': true,
    'slidesToShow': 1,
    appendArrows : '.js-history-slider',
    nextArrow: '<button type="button" class="slick__next fas fa-chevron-right"></button>',
    prevArrow: '<button type="button" class="slick__prev fas fa-chevron-left"></button>',
    'responsive': [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          appendArrows: '.js-history-slider .slick-list',
        },
      },
    ],
  });

};
export default history_slider;
